export default __webpack_public_path__ + "beta-maps-examples-user-location-view-thumbnail-960-09a8e03c3e516f515204e27210711446.webp";